import React, { useState } from 'react';
import {
    Box,
    Collapse,
    Typography,
    Grid,
    Button,
    Divider,
} from '@mui/material';
import FormTextField from '../../../../components/FormFields/FormTextField';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import FormSelectMultiple from './FormSelectMultiple';
import HenkiloImageUploader from './ImageUploader/HenkiloImageUploader';
import { useAddNewPersonMutation } from '../../../../api/peopleApiSlice';
import { useGetYhteystiedotQuery } from '../../../../api/yhteystiedotApiSlice';

const HenkilotAddForm = ({ initialValues, onSuccess, onError }) => {
    const [showForm, setShowForm] = useState(false);
    const [showOptionalFields, setShowOptionalFields] = useState(false);
    const [addPersonData, setAddPersonData ] = useState({ nimi: '', email: '', titteli: '', puhelinnumero: '', puhelinnumero2: '', yhteystiedot: [], henkilokuva: null, tyonkuva: '', liity_lahettajaksi: '' });
    const [addNewPerson] = useAddNewPersonMutation();
    const { data: yhteystiedot } = useGetYhteystiedotQuery();
    const yhteystietoArray = yhteystiedot?.entities
        ? Object.values(yhteystiedot.entities).map(item => item.yhteystieto)
        : [];

    const handleLisääPerson = async(person) => {
        try {
            const result = await addNewPerson(person);
            if(result.error) onError('Henkilön luominen epäonnistui');
            if(!result.error) onSuccess('Henkilön luominen onnistui.', 'henkilot', result.data.id);
            setAddPersonData({ nimi: '', email: '', titteli: '', puhelinnumero: '', puhelinnumero2: '', yhteystiedot: [], henkilokuva: null, tyonkuva: '', liity_lahettajaksi: '' });
            setShowOptionalFields(false);
            setShowForm(false);
        } catch (error) {
            console.error(error); // handle error
        }};

    const handleUpdateAddPersonData = (selectedItems) => {
        setAddPersonData((prevState) => ({
            ...prevState,
            yhteystiedot: selectedItems
        }));
    };

    const handleImageChange = (imageData) => {
        setAddPersonData((prevState) => ({ ...prevState, henkilokuva: imageData }));
    };

    return (
        <Box
            sx={{
                flexGrow: 1,
            }}
        >
            {showForm && (
                <Box sx={{
                    flexGrow: 1, // Add flexGrow to make the box grow
                }}>
                    <Typography variant="h6" sx={{ pt: 2, mb: 2 }}>Henkilön luominen</Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                        Luo henkilö nopeasti täyttämällä vain nimi. Muut tiedot ovat valinnaisia.
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={8}>
                            <FormTextField
                                key="addPersonNimi"
                                fieldName='nimi'
                                label='nimi *'
                                multiline={true}
                                fullWidth={true}
                                value={addPersonData.nimi}
                                onChange={(event) => setAddPersonData({ ...addPersonData, nimi: event.target.value })}
                                sx={{ width: '100%' }}
                            />
                        </Grid>
                        <Grid item xs={12} md={8}>
                            <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ mt: 0.5 }}>
                                <Button
                                    variant="text"
                                    onClick={() => setShowOptionalFields((prev) => !prev)}
                                    sx={{ px: 0, minWidth: 0 }}
                                >
                                    {showOptionalFields ? 'Piilota valinnaiset lisätiedot' : 'Näytä valinnaiset lisätiedot'}
                                </Button>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={8}>
                            <Collapse in={showOptionalFields}>
                                <Divider sx={{ mb: 2 }}>Valinnaiset lisätiedot</Divider>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <FormTextField
                                            error={false}
                                            key="addPersonEmail"
                                            fieldName='email'
                                            label='email'
                                            multiline={true}
                                            fullWidth={true}
                                            value={addPersonData.email}
                                            onChange={(event) => setAddPersonData({ ...addPersonData, email: event.target.value })}
                                            sx={{ width: '100%' }}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormTextField
                                            error={false}
                                            key="addPersonTitteli"
                                            fieldName='titteli'
                                            label='titteli'
                                            multiline={true}
                                            fullWidth={true}
                                            value={addPersonData.titteli}
                                            onChange={(event) => setAddPersonData({ ...addPersonData, titteli: event.target.value })}
                                            sx={{ width: '100%' }}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormTextField
                                            key="addPersonPuhelinnumero"
                                            fieldName='puhelinnumero'
                                            label='puhelinnumero'
                                            multiline={true}
                                            fullWidth={true}
                                            value={addPersonData.puhelinnumero}
                                            onChange={(event) => setAddPersonData({ ...addPersonData, puhelinnumero: event.target.value })}
                                            sx={{ width: '100%' }}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormTextField
                                            key="addPersonPuhelinnumero2"
                                            fieldName='puhelinnumero2'
                                            label='2. puhelinnumero'
                                            multiline={true}
                                            fullWidth={true}
                                            value={addPersonData.puhelinnumero2}
                                            onChange={(event) => setAddPersonData({ ...addPersonData, puhelinnumero2: event.target.value })}
                                            sx={{ width: '100%' }}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormTextField
                                            key="addPersonTyonkuva"
                                            fieldName='tyonkuva'
                                            label='työnkuva'
                                            multiline={true}
                                            fullWidth={true}
                                            value={addPersonData.tyonkuva}
                                            onChange={(event) => setAddPersonData({ ...addPersonData, tyonkuva: event.target.value })}
                                            sx={{ width: '100%' }}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormTextField
                                            key="addPersonLiityLahettajaksi"
                                            fieldName='liity_lahettajaksi'
                                            label='liity lähettäjäksi'
                                            multiline={true}
                                            fullWidth={true}
                                            value={addPersonData.liity_lahettajaksi}
                                            onChange={(event) => setAddPersonData({ ...addPersonData, liity_lahettajaksi: event.target.value })}
                                            sx={{ width: '100%' }}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormSelectMultiple
                                            key="addPersonYhteystiedot"
                                            fieldName='addyhteystiedot'
                                            existingYhteystiedot={addPersonData.yhteystiedot}
                                            label='Yhteystiedot'
                                            onUpdate={handleUpdateAddPersonData}
                                            options={yhteystietoArray}
                                            multiline={true}
                                            fullWidth={true}
                                            sx={{ width: '100%' }}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant='subtitle1' sx={{ mb: 1 }}>Henkilökuva</Typography>
                                        <HenkiloImageUploader fieldName='henkilokuva' onImageChange={handleImageChange}/>
                                    </Grid>
                                </Grid>
                            </Collapse>
                        </Grid>
                        <Box display="flex" justifyContent="flex-end" width="100%" pt={1}>

                            <Button
                                disabled={!addPersonData.nimi.trim()}
                                onClick={() => handleLisääPerson(addPersonData)}
                                size="small"
                                variant="contained"
                                startIcon={<AddIcon />}
                                sx={{ backgroundColor: 'taphaGreen.main' }}
                            >
          Tallenna
                            </Button>
                        </Box>
                    </Grid>
                </Box>
            )}
            {showForm ? (
                <Box display='flex' justifyContent='flex-end' width='100%' pt={1}>
                    <Button
                        onClick={() => {
                            setShowForm(!showForm);
                            setShowOptionalFields(false);
                        }}
                        size='small'
                        variant='contained'
                        startIcon={<CloseIcon />}
                        sx={{ backgroundColor: 'taphaBlue.main' }}
                    >
                    Sulje
                    </Button>
                </Box>
            ) :
                (<Box display='flex' justifyContent='flex-end' width='100%' pt={1}>
                    <Button
                        onClick={() => setShowForm(!showForm)}
                        size='small'
                        variant='contained'
                        startIcon={<AddIcon />}
                        sx={{ backgroundColor: 'taphaBlue.main' }}
                    >
                    Luo henkilö
                    </Button>
                </Box>)}
        </Box>
    );
};

export default HenkilotAddForm;